import { render } from "./SelectPlusField.vue?vue&type=template&id=19de154c"
import script from "./SelectPlusField.vue?vue&type=script&lang=js"
export * from "./SelectPlusField.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"SelectPlusField.vue"]])

export default __exports__